export const content = {
    title: '5-Star\n<mark class="goldMark">Global Apartment Ownership</mark>\nFor Nomads',
    subtitle: 'Stop wasting money on short term rentals and diversify your portfolio by investing in prime real estate. The only service that lets you buy and own apartments in world class cities to live-in or rent-out completely hassle free. You can find European city center apartments today from $175,000.',
    buttonCTA: 'Try It With a Free Stay',
    belowButton: '(it\'s <u style="text-underline-offset: 6px;" >not timeshare</u>)',
}